import { ref, get, update } from 'firebase/database';

export const APP_LINK_ARCHIVE_FIELD = 'archivedAppLink';

const getCompanyPostsSnapshot = async (database, companyUID) => {
  if (!database || !companyUID) return null;
  const postsRef = ref(database, `companies/${companyUID}/posts`);
  const snapshot = await get(postsRef);
  return snapshot.exists() ? snapshot : null;
};

export const archiveCompanyApplicationTargets = async (database, companyUID) => {
  try {
    const snapshot = await getCompanyPostsSnapshot(database, companyUID);
    if (!snapshot) return;

    const posts = snapshot.val();
    const updates = {};

    Object.entries(posts).forEach(([jobId, jobData]) => {
      if (jobData?.applicationMethod === 'external') return;
      const currentAppLink = jobData?.appLink;
      const archivedAppLink = jobData?.[APP_LINK_ARCHIVE_FIELD];

      if (!currentAppLink && !archivedAppLink) {
        return;
      }

      const selectedLink = currentAppLink || archivedAppLink;

      updates[`companies/${companyUID}/posts/${jobId}/${APP_LINK_ARCHIVE_FIELD}`] = selectedLink || null;
      updates[`companies/${companyUID}/posts/${jobId}/appLink`] = null;
    });

    if (Object.keys(updates).length > 0) {
      await update(ref(database), updates);
    }
  } catch (error) {
    console.error('archiveCompanyApplicationTargets error:', error);
  }
};

export const restoreCompanyApplicationTargets = async (database, companyUID) => {
  try {
    const snapshot = await getCompanyPostsSnapshot(database, companyUID);
    if (!snapshot) return;

    const posts = snapshot.val();
    const updates = {};

    Object.entries(posts).forEach(([jobId, jobData]) => {
      if (jobData?.applicationMethod === 'external') return;
      const archivedAppLink = jobData?.[APP_LINK_ARCHIVE_FIELD];

      if (!archivedAppLink) {
        return;
      }

      updates[`companies/${companyUID}/posts/${jobId}/appLink`] = archivedAppLink;
      updates[`companies/${companyUID}/posts/${jobId}/${APP_LINK_ARCHIVE_FIELD}`] = null;
    });

    if (Object.keys(updates).length > 0) {
      await update(ref(database), updates);
    }
  } catch (error) {
    console.error('restoreCompanyApplicationTargets error:', error);
  }
};

export const clearCompanyApplicationTargetArchive = async (database, companyUID) => {
  try {
    const snapshot = await getCompanyPostsSnapshot(database, companyUID);
    if (!snapshot) return;

    const posts = snapshot.val();
    const updates = {};

    Object.keys(posts).forEach((jobId) => {
      if (posts[jobId]?.applicationMethod === 'external') return;
      updates[`companies/${companyUID}/posts/${jobId}/appLink`] = null;
      updates[`companies/${companyUID}/posts/${jobId}/${APP_LINK_ARCHIVE_FIELD}`] = null;
    });

    if (Object.keys(updates).length > 0) {
      await update(ref(database), updates);
    }
  } catch (error) {
    console.error('clearCompanyApplicationTargetArchive error:', error);
  }
};
